import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';
import './tooltip.scss';

const styles = bemGenerator('pj-ui-tooltip', ['content']);

const Tooltip = props => {
  const { children, position, className, active } = props;

  return (
    <span
      className={`${styles.block.withModifier({
        [position]: true,
        active,
      })} ${className}`}
    >
      <span className={styles.content}>{children}</span>
    </span>
  );
};

const { string, node, oneOf, bool } = PropTypes;

Tooltip.propTypes = {
  children: node.isRequired,
  position: oneOf(['top', 'right', 'bottom', 'left']),
  className: string,
  active: bool,
};

Tooltip.defaultProps = {
  position: 'top',
  className: '',
  active: true,
};

export default Tooltip;
